var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.56 1.901L2.604.323l.888-.29C4.97-.449 7.12 4.461 5.89 5.563L4.172 7.06c-1.539 1.38 3.626 8.755 5.449 7.781l1.994-1.103c1.456-.777 5.334 2.922 4.376 4.145l-.576.736L13.233 20C5.368 20.007-2.137 9.29.56 1.901z",
    fill: "#E469D1",
    opacity: 0.4
  })));
};

export default SvgPhone;